import React, { createContext, useContext } from "react";

// Ver TAREA: pantalla Perfil + reorganización de la barra inferior.
// "Más" desapareció de la barra -- su sheet (buscador, Fijados,
// acordeones, Idioma, Refrescar, Volumen, Mi cuenta, Cerrar sesión) sigue
// viviendo tal cual en layout/index.js (mismo estado moreMenuOpen, mismo
// Drawer, nada de ese contenido se tocó), solo que ahora lo dispara el FAB
// "Configuración" de PerfilPage en vez del botón "Más" de la barra. Este
// context es el puente: layout/index.js provee openMenu (== setMoreMenuOpen(true)),
// PerfilPage lo consume -- mismo patrón que Citas ya usa con su propio
// PerfilMenuContext para el mismo problema (FAB en una página hija que
// necesita abrir un sheet que vive en el layout padre).
const PerfilMenuContext = createContext({ openMenu: () => {} });

export const PerfilMenuProvider = ({ openMenu, children }) => (
  <PerfilMenuContext.Provider value={{ openMenu }}>
    {children}
  </PerfilMenuContext.Provider>
);

export const usePerfilMenu = () => useContext(PerfilMenuContext);

export default PerfilMenuContext;
